<template>
  <v-card flat>
    <v-card-text>
      <template>
        <v-card class="main-content-card" flat>
          <v-container fluid grid-list-md class="px-4" style="background-color: rgba(245, 245, 245, 0.6);">
            <v-layout row wrap>
              <v-flex d-flex xs10>
                <v-layout row wrap>
                  <v-flex xs12 sm2>
                    <v-menu
                      ref="menuIncomeDateStart"
                      :close-on-content-click="false"
                      v-model="menuIncomeDateStart"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="editItem.incomeDateStart"
                        label="起始时间"
                        :rules="rules.startDate"
                        hint="格式YYYY-MM, 如：2018-10"
                        persistent-hint
                      />
                      <v-date-picker
                        v-model="incomeDateStart"
                        type="month"
                        locale="zh-cn"
                        @change="nv => editItem.incomeDateStart= nv"
                      />
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm2>
                    <v-menu
                      ref="menuIncomeDateEnd"
                      :close-on-content-click="false"
                      v-model="menuIncomeDateEnd"
                      lazy
                      transition="scale-transition"
                      offset-y
                      full-width
                      max-width="290px"
                    >
                      <v-text-field
                        slot="activator"
                        v-model="editItem.incomeDateEnd"
                        label="截止时间"
                        :rules="rules.endDate"
                        hint="格式YYYY-MM, 如：2018-10"
                        persistent-hint
                      />
                      <v-date-picker
                        v-model="incomeDateEnd"
                        type="month"
                        locale="zh-cn"
                        @change="nv => editItem.incomeDateEnd= nv"
                      />
                    </v-menu>
                  </v-flex>
                  <v-flex xs12 sm4>
                    <v-autocomplete
                      item-text="name"
                      item-value="dbid"
                      :items="deptItems"
                      v-model="editItem.deptId"
                      :rules="rules.deptId"
                      label="主管部门"
                      hide-details
                      clearable
                      :menu-props="{maxHeight:600}"
                    />
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex d-flex xs2 text-xs-center>
                <div>
                  <v-btn color="primary" @click="onSearch">
                    <v-icon dark>search</v-icon>
                    检索
                  </v-btn>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
        <v-divider/>
        <v-container fluid grid-list-sm>
          <v-layout row wrap>
            <!--  科研规模年度统计 -->
            <v-flex xs12 sm6 md6 lg4 style="height: 240px">
              <v-card tile>
                <v-card-text>
                </v-card-text>
                <v-card-text>
                  <fund-contract-receive-by-date
                  :start-date="startDate"
                  :end-date="endDate"
                  :dept-id="deptId"/>
                </v-card-text>
                <v-card-text>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6 lg8  style="height: 240px">
              <v-card tile>
                <v-card-text class="text-xs-center">
                  <fund-by-year-statistics
                    :start-date="startDate"
                    :end-date="endDate"
                    :dept-id="deptId"
                    style="max-width: 400px;margin: 0 auto;"/>
                </v-card-text>
              </v-card>
            </v-flex>
            <v-flex xs12>
              <fund-count-by-level-and-index
                :start-date="startDate"
                :end-date="endDate"
                :dept-id="deptId"/>
            </v-flex>
            <v-flex xs6 sm3 md3 lg6>
              <college-project-statistics
                :start-date="startDate"
                :end-date="endDate"
                :dept-id="deptId"/>
            </v-flex>
            <v-flex xs6 sm3 md3 lg6>
              <college-platform-team-statistics
                :start-date="startDate"
                :end-date="endDate"
                :dept-id="deptId"/>
            </v-flex>
            <v-flex xs6 sm3 md3 lg12>
              <college-project-level-statistics
                :start-date="startDate"
                :end-date="endDate"
                :dept-id="deptId"/>
            </v-flex>
          </v-layout>
        </v-container>
      </template>
    </v-card-text>
  </v-card>
</template>

<script>
  import FundByYearStatistics from './FundByYearStatistics'
  import FundContractReceiveByDate from './FundContractReceiveByDate'
  import FundCountByLevelAndIndex from './FundCountByLevelAndIndex'
  import CollegeProjectStatistics from './CollegeProjectStatistics'
  import CollegePlatformTeamStatistics from "./CollegePlatformTeamStatistics"
  import CollegeProjectLevelStatistics from "./CollegeProjectLevelStatistics"
  const deptUri = '/api/syst/department';
  export default {
    name: "FundSearch",
    components: {
      FundContractReceiveByDate,
      FundByYearStatistics,
      FundCountByLevelAndIndex,
      CollegeProjectStatistics,
      CollegePlatformTeamStatistics,
      CollegeProjectLevelStatistics
    },
    data () {
      return {
        startDate: "",
        endDate: "",
        deptId:"",
        loading: false,
        //开始时间
        menuIncomeDateStart: false,
        incomeDateStart:null,

        menuIncomeDateEnd: false,
        incomeDateEnd:null,
        editItem: {
          "incomeDateStart":"",
          "incomeDateEnd": "",
          "deptId": ""
        },
        deptItems: [],
        /**
         * 验证规则
         */
        rules: {
          required: [
            v => !!v || '必填项。'],
          startDate: [
            v => !!v || "必填项。",
            v => window.xutil.regexpMonth().test(v) || '日期格式错误'
          ],
          endDate: [
            v => !!v || "必填项。",
            v => (v && window.xutil.regexpMonth().test(v)) || '日期格式错误',
            v => (v && v > this.editItem.incomeDateStart) || "截止日期必须晚于起始日期。"
          ]
        },

      }
    },
    created() {
      const vm = this;
      if (vm.editItem.incomeDateStart) {
        const val = vm.editItem.incomeDateStart.trim();
        if (val.length > 0) {
          vm.startDate = val;
        }
      }
      else {
        var date = new Date();
        var seperator1 = "-";
        var year = date.getFullYear()-9;
        var month = date.getMonth() + 1;
        var strDate = date.getDate();
        if (month >= 1 && month <= 9) {
          month = "0" + month;
        }
        var enddate = year + seperator1 + month;
        vm.editItem.incomeDateStart = enddate;
        vm.startDate = enddate;
      }
      if (vm.editItem.incomeDateEnd) {
        const val = vm.editItem.incomeDateEnd.trim();
        if (val.length > 0) {
          vm.endDate = val;
        }
      }
      else {
        var currentdate = new Date().toISOString().substr(0,7);
        vm.editItem.incomeDateEnd = currentdate;
        vm.endDate = currentdate;
      }

      if (vm.editItem.deptId) {
        const val = vm.editItem.deptId.trim();
        if (val.length > 0) {
          vm.deptId = val;
        }
      }
      else{
        vm.deptId = "";
      }

      // 加载审核状态
      this.axios.all([
        this.axios.get(deptUri, {params: {limit: 65535, disabled: 'F', sort: 'rank.asc'}}),
      ]).then(
        this.axios.spread(
          ( rspDept) => {
            this.deptItems = rspDept.data.items.filter(v => v.isAdmin || !v.parent);
          }
        )
      )
    },
    watch: {

    },

    computed: {

    },

    methods: {
      // 检索响应函数
      onSearch() {
        const vm = this;
        if (vm.editItem.incomeDateStart) {
          const val = vm.editItem.incomeDateStart.trim();
          if (val.length > 0) {
            vm.startDate = val;
          }
        }
        else {
          var date = new Date();
          var seperator1 = "-";
          var year = date.getFullYear()-9;
          var month = date.getMonth() + 1;
          var strDate = date.getDate();
          if (month >= 1 && month <= 9) {
            month = "0" + month;
          }
          var enddate = year + seperator1 + month;
          vm.editItem.incomeDateStart = enddate;
          vm.startDate = enddate;
        }
        if (vm.editItem.incomeDateEnd) {
          const val = vm.editItem.incomeDateEnd.trim();
          if (val.length > 0) {
            vm.endDate = val;
          }
        }
        else {
          var currentdate = new Date().toISOString().substr(0,7);
          vm.editItem.incomeDateEnd = currentdate;
          vm.endDate = currentdate;
        }
        if (vm.editItem.deptId) {
          const val = vm.editItem.deptId.trim();
          if (val.length > 0) {
            vm.deptId = val;
          }
        }
        else{
          vm.deptId = "";
        }
      }
    }
  }
</script>

<style scoped>

</style>
